
//live hostinger rener code is: (when you going for live to upload code we need to it in live code)
export const API_BASE_URL = "https://fds-backend-79aa.onrender.com";

//local rener code is:
//export const API_BASE_URL = "http://localhost:5000";
